var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"board-loading-bg"}},[_c('div',{staticClass:"board-loading"},[_c('div',{staticClass:"board-effect-1 effects"}),_c('div',{staticClass:"board-effect-2 effects"}),_c('div',{staticClass:"board-effect-3 effects"})])])
}]

export { render, staticRenderFns }